/* eslint-disable no-underscore-dangle */
import { Observable, BehaviorSubject } from 'rxjs';
import { StorageService } from '../services/storage.service';

export class Store<T> {
  state$: Observable<T>;
  private _state$: BehaviorSubject<T>;

  protected constructor(
    private initialState: T,
    private localStorageRef: string,
    private storageService: StorageService
  ) {
    this._state$ = new BehaviorSubject(initialState);
    this.state$  = this._state$.asObservable();
  }

  get state(): T {
    return this._state$.getValue();
  }

  setState(nextState: T): void {
    this._state$.next(nextState);
    this.save();
  }

  async load(): Promise<T> {
    const state = JSON.parse(await this.storageService.get(this.localStorageRef));
    console.log('loaded -> ', this.localStorageRef, ' state', state);

    if (state) {
      this.setState(state as T);
      return state;
    } else {
      return this.state;
    }
  }

  save() {
    this.storageService.set(this.localStorageRef, JSON.stringify(this.state));
  }

  clear() {
    this.storageService.remove(this.localStorageRef);
    this._state$.next({} as T);
  }
}
